import React, { useState } from 'react';
import Combustible from './Combustible';
import AdBlue from './AdBlue';

export default function CombustibleAdBlue() {
  const [tab, setTab] = useState('combustible');

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {[['combustible', '⛽ Combustible'], ['adblue', '🔵 AdBlue']].map(([val, label]) => (
          <button key={val} onClick={() => setTab(val)} style={{
            padding: '8px 18px', borderRadius: 8, border: 'none', cursor: 'pointer',
            fontSize: 13, fontWeight: 600,
            background: tab === val ? '#1a1a1a' : '#f0f0f0',
            color: tab === val ? '#fff' : '#555'
          }}>{label}</button>
        ))}
      </div>
      {tab === 'combustible' ? <Combustible /> : <AdBlue />}
    </div>
  );
}
